import {eatClubClient} from "@globals/config/apiClient";
import {DateString} from "@globals/types/utilityTypes";

import {BannerImageItem, ImageBannerName} from "./intefaces";

export function getBanner(
  name: ImageBannerName,
  date: DateString,
  location_id?: number
): Promise<BannerImageItem> {
  const config = {
    params: {
      name,
      date,
      location_id,
    },
  };
  return eatClubClient
    .get("/api/image_banner/", config)
    .then((response) => response.data);
}
